import React from 'react';
import './AboutUs.css';
import imgss from "../../assets/images/kidss.avif";
import Footer from '../../components/Footer/Footer';
import inside1 from '../../assets/shopimage/inim1.jpg'
import inside2 from '../../assets/shopimage/inim2.jpg'
import inside3 from '../../assets/shopimage/inim3.jpg'
import inside4 from '../../assets/shopimage/inim4.jpg'
const stores = [
    {
        name: 'SWARNA',
        location: 'GROUND FLOOR',
        image: inside1, // Replace with actual image paths
    },
    {
        name: 'NEKLACE SECTIONS',
        location: 'SECTION1 GF',
        image: inside2,
    },
    {
        name: 'SILVER SECTIONS',
        location: 'FIRST FLOOR',
        image: inside3,
    },
    {
        name: 'DIAMOND COLLECTIONS',
        location: 'FIRST FLOOR',
        image: inside4,
    },
  ];

const AboutUs = () => {
    return (
        <>
            <div className="about-container">
                <img src={imgss} alt="" className='abtimg' />
                <header className="about-hero">
                    <h1>Welcome to</h1>
                    <h1>AVNII JEWELLERS</h1>
                    <p className='desp'>A new chapter in a legacy of fine jewellery</p>
                </header>

                <h2>ABOUT US</h2>
                <section className="about-content container">
                    <div className="about-section">
                        <p>
                            <strong>Welcome to Swarna Prakash Jewellers, a new chapter in a legacy of fine jewellery.</strong>
                        </p>
                        <p>
                            <strong>
                                Established in May 2024, Swarna Prakash Jewellers is a proud third-generation family-owned business,
                                continuing a tradition of excellence in the world of exquisite jewellery. Located in Joduraste, Karkala,
                                our spacious 4,000 sq. ft. showroom is home to a stunning collection of gold, silver, and diamond jewellery—each piece crafted to inspire and delight.
                            </strong>
                        </p>
                        <p>
                            <strong>
                                We specialize in designing both timeless classics and modern creations, with a deep focus on personalized
                                service and uncompromising quality. Our skilled artisans, drawing upon generations of expertise, bring
                                your unique visions to life with extraordinary attention to detail. We offer a wide range of customization
                                options, including bespoke diamond jewellery in 14kt and 18kt gold, featuring both natural and lab-grown diamonds.
                            </strong>
                        </p>
                        <p>
                            <strong>
                                At Swarna Prakash Jewellers, we believe jewellery is more than just adornment—it’s an expression of personal
                                style and a celebration of life’s special moments. We are committed to providing a warm and memorable shopping
                                experience, guided by a friendly and knowledgeable team dedicated to helping you find the perfect piece that reflects
                                your taste and fits your budget.
                            </strong>
                        </p>
                        <p>
                            <strong>
                                To bring this experience to the digital world, we also operate <strong>Avnii Jewellers</strong>, our official
                                e-commerce platform for jewellery shopping. Avnii Jewellers is an online initiative by Swarna Prakash Jewellers,
                                designed to offer you the same trust, quality, and service—just with the convenience of online shopping. While the
                                brand name Avnii Jewellers is used for our digital presence, all orders, payments, and invoices are securely
                                processed and billed under Swarna Prakash Jewellers. This ensures full transparency and continuity of service.
                            </strong>
                        </p>
                        <p>
                            <strong>
                                We invite you to visit our showroom or explore our collection online at <strong>Avnii Jewellers</strong>, and
                                experience the brilliance and trust that define Swarna Prakash Jewellers.
                            </strong>
                        </p>
                    </div>
                </section>
                <div className="container viv">
                <section className="store-section storecont">
                    <h2 className="store-heading ourc">Visit Our Store</h2>
                    <div className="store-gridc">
                        {stores.map((store, idx) => (
                            <div className="store-card" key={idx}>
                                <img src={store.image} alt={store.name} className="store-image" />
                                <h3 className="store-name">{store.name}</h3>
                                <p className="store-location">{store.location}</p>
                            </div>
                        ))}
                    </div>
                </section>
                </div>

                <footer className="about-footer">
                    <p>Experience the brilliance of Swarna Prakash Jewellers in Karkala today.</p>
                </footer>
            </div>
            <Footer />
        </>
    );
};

export default AboutUs;
